export default function Container({ children }) {
  return <div className="overflow-x-hidden w-full pt-10">{children}</div>;
}
